import * as angular from "angular";
import $ = require("jquery"); 
import "../../Scripts/jquery.layout-1.4";

import { directivesModule } from "../directivesModule";
import "../directivesModule";

import { PaneController } from "./LayoutController";
import "./LayoutController";

interface ILayoutDirectiveScope extends angular.IScope {
	showNorth: boolean;
	showSouth: boolean;
	showEast: boolean;
	showWest: boolean;
	openNorth: boolean;
	openSouth: boolean;
	openEast: boolean;
	openWest: boolean;
}

class LayoutDirective implements angular.IDirective{


	constructor(private $rootScope: angular.IRootScopeService) {

	}

	public link(scope: ILayoutDirectiveScope, element, attrs) {
		var options = {
			defaults: {
				applyDefaultStyles: false,
				resizable: true,
				slidable: false,
				fxName: 'none'
			},
			north: {
				initHidden: angular.isUndefined(attrs.northsize),
				initClosed: angular.isUndefined(attrs.northsize),
				size: undefined
			},
			south: {
				initHidden: angular.isUndefined(attrs.southsize),
				initClosed: angular.isUndefined(attrs.southsize),
				size: undefined
			},
			east: {
				initHidden: angular.isUndefined(attrs.eastsize),
				initClosed: angular.isUndefined(attrs.eastsize),
				size: undefined
			},
			west: {
				initHidden: angular.isUndefined(attrs.westsize),
				initClosed: angular.isUndefined(attrs.westsize),
				size: undefined
			},
			center: {
			},
			onopen:  (panename) => {
				
				if (panename === 'west') {
					scope.openWest = true; 
				}
				else if (panename = 'south') {
					scope.openSouth = true; 
				}
				else if (panename = 'north') {
					scope.openNorth = true; 
				}
				else if (panename = 'east') {
					scope.openEast = true; 
				}
				this.$rootScope.$broadcast("layout", { method: "open", pane: panename });
				//scope.$apply();
			},
			onclose:  (panename) => {
				
				if (panename === 'west') {
					scope.openWest = false;
				}
				else if (panename = 'south') {
					scope.openSouth = false;
				}
				else if (panename = 'north') {
					scope.openNorth = false;
				}
				else if (panename = 'east') {
					scope.openEast = false;
				}
				this.$rootScope.$broadcast("layout", { method: "close", pane: panename });
				//scope.$apply();
			},
			onshow: (panename) => {
				this.$rootScope.$broadcast("layout", { method: "show", pane: panename });
			},
			onhide: (panename) => {
				this.$rootScope.$broadcast("layout", { method: "hide", pane: panename });
			},
			onresize:  (panename) => {
				this.$rootScope.$broadcast("layout", { method: "resize", pane: panename });
			}
		};
		if (angular.isDefined(attrs.westsize)) {
			options.west.size = parseInt(attrs.westsize);
		}
		if (angular.isDefined(attrs.eastsize)) {
			options.east.size = parseInt(attrs.eastsize);
		}

		if (angular.isDefined(attrs.northsize)) {
			options.north.size = parseInt(attrs.northsize);
		}
		if (angular.isDefined(attrs.southsize)) {
			options.south.size = parseInt(attrs.southsize);
		}

		if (angular.isDefined(scope.showNorth)) {
			options.north.initHidden = !(scope.showNorth);
		}

		if (angular.isDefined(scope.showSouth)) {
			options.south.initHidden = !(scope.showSouth);
		}

		if (angular.isDefined(scope.showEast)) {
			options.east.initHidden = !(scope.showEast);
		}

		if (angular.isDefined(scope.showWest)) {
			options.west.initHidden = !(scope.showWest);
		}

		if (angular.isDefined(scope.openNorth)) {
			options.north.initClosed = !(scope.openNorth);
		}

		if (angular.isDefined(scope.openSouth)) {
			options.south.initClosed = !(scope.openSouth);
		}

		if (angular.isDefined(scope.openEast)) {
			options.east.initClosed = !(scope.openEast);
		}

		if (angular.isDefined(scope.openWest)) {
			options.west.initClosed = !(scope.openWest);
		}

		var instanceVariable = element.layout(options);

		scope.$watch('showNorth',  (newVal, oldVal) => {
			if (newVal !== undefined && instanceVariable.north && instanceVariable.north.state && newVal !== !instanceVariable.north.state.isHidden) {
				if (newVal && newVal.toString().toLowerCase() === 'true') {
					instanceVariable.show('north');
				}
				else {
					instanceVariable.hide('north');
				}
			}
		});

		scope.$watch('showSouth',  (newVal, oldVal) => {
			if (newVal !== undefined && instanceVariable.south && instanceVariable.south.state && newVal !== !instanceVariable.south.state.isHidden) {
				if (newVal && newVal.toString().toLowerCase() === 'true') {
					instanceVariable.show('south');
				}
				else {
					instanceVariable.hide('south');
				}
			}
		});

		scope.$watch('showEast',  (newVal, oldVal) => {
			if (newVal !== undefined && instanceVariable.east && instanceVariable.east.state && newVal !== !instanceVariable.east.state.isHidden) {
				if (newVal && newVal.toString().toLowerCase() === 'true') {
					instanceVariable.show('east');
				}
				else {
					instanceVariable.hide('east');
				}
			}
		});

		scope.$watch('showWest', (newVal, oldVal) => {
			if (newVal !== undefined && instanceVariable.west && instanceVariable.west.state && newVal !== !instanceVariable.west.state.isHidden) {
				if (newVal && newVal.toString().toLowerCase() === 'true') {
					instanceVariable.show('west');
				}
				else {
					instanceVariable.hide('west');
				}
			}

		});


		scope.$watch('openNorth',  (newVal, oldVal) => {
			if (newVal !== oldVal && instanceVariable) {
				if (newVal && newVal.toString().toLowerCase() === 'true') {
					instanceVariable.open('north');
				}
				else {
					instanceVariable.close('north');
				}

			}
		});

		scope.$watch('openSouth',  (newVal, oldVal) => {
			if (newVal !== oldVal && instanceVariable) {
				if (newVal && newVal.toString().toLowerCase() === 'true') {
					instanceVariable.open('south')
				}
				else {
					instanceVariable.close('south')
				}
			}
		});

		scope.$watch('openEast',  (newVal, oldVal) => {
			if (newVal !== oldVal && instanceVariable) {
				if (newVal && newVal.toString().toLowerCase() === 'true') {
					instanceVariable.open('east');
				}
				else {
					instanceVariable.close('east');
				}

			}
		});

		scope.$watch('openWest',  (newVal, oldVal) => {
			if (newVal !== oldVal && instanceVariable) {
				if (newVal && newVal.toString().toLowerCase() === 'true') {
					instanceVariable.open('west')
				}
				else {
					instanceVariable.close('west')
				}
			}
		});

		this.$rootScope.$on('resize-content',  (event, parms) => {
			instanceVariable.sizePane(parms[0], parms[1], true, true, true);

		});

	}

	public restrict: string = 'AE';
	public scope: any = {
		showNorth: '<',
		showSouth: '<',
		showEast: '<',
		showWest: '<',
		openNorth: '=?',
		openSouth: '=?',
		openEast: '=?',
		openWest: '=?'
	}
}

directivesModule.directive('bvLayout', ['$rootScope', ($rootScope) => new LayoutDirective($rootScope)]);



// WEBPACK FOOTER //
// ./Common/Layout/LayoutDirective.ts